interface SignupHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
}

export function SignupHeader({ title, subtitle, className = '' }: SignupHeaderProps) {
  return (
    <div className={`text-center mb-8 ${className}`}>
      <h1 className="text-[32px] font-bold text-[#222222] mb-4">{title}</h1>
      {subtitle && (
        <h2 className="text-[20px] font-semibold text-[#222222]">
          {subtitle}
        </h2>
      )}
    </div>
  );
}